import React from 'react';
import { getIsRequestPending } from '../../../../shared/utils';
import { accessibleOnClick } from '../../../../shared/utils/accessible-on-click';
import { TaskStatusKey } from '../../utils/enums';
import { getTaskStatusArray } from '../../utils/helper';
import type { IProps } from './tasks-header-container';
import { formatNumberToKM } from '../../../sequence/helpers/helper';

const TasksHeader: React.FC<IProps> = ({
  taskStatus,
  onChange,
  taskStatusCount,
  getTasksRequestStatus,
  getTasksStatusCountRequestStatus,
  localTaskStatusCount,
}) => {
  const onTaskStatusChange = (status: TaskStatusKey) => {
    if (getIsRequestPending(getTasksRequestStatus) || taskStatus === status) {
      return;
    }
    onChange(status);
  };

  const isStatusCountPending = getIsRequestPending(
    getTasksStatusCountRequestStatus,
  );

  // Use local task status counts if available, otherwise fall back to Redux state
  const effectiveTaskStatusCount = localTaskStatusCount || taskStatusCount;

  return (
    <div className="tasks__header">
      {getTaskStatusArray().map(({ label, key }) => (
        <div
          key={key}
          className={`tasks__header--item ${
            key === taskStatus && 'tasks__header--active'
          }`}
          {...accessibleOnClick(() => onTaskStatusChange(key))}
        >
          <div className="d-flex align-items-center">
            <span
              className={`regular-2 font-medium line-height-20 label ${
                key === taskStatus ? 'font-semibold blue-txt-11' : 'gray-txt-30'
              }`}
            >
              {label}
            </span>

            {!isStatusCountPending && (
              <span
                className={`ml-1 regular-1 font-medium count ${
                  key === TaskStatusKey.Overdue || key === TaskStatusKey.Failed
                    ? 'red-txt-18 red-19'
                    : 'gray-txt-15 gray-16'
                }`}
              >
                {effectiveTaskStatusCount
                  ? formatNumberToKM(Number(effectiveTaskStatusCount[key]))
                  : 0}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TasksHeader;
